var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<script src=\"https://script.tapfiliate.com/tapfiliate.js\" type=\"text/javascript\" async></script><script type=\"text/javascript\">(function(t,a,p){t.TapfiliateObject=a;t[a]=t[a]||function(){ (t[a].q=t[a].q||[]).push(arguments)}})(window,'tap');\n\ntap('create', '5291-365936');\ntap('detect');</script>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/tapfiliate/tapfiliate.jade
// module id = 518
// module chunks = 0